import jiraService from "./jiraService";

export const JiraService = {
  getTicketsData: jiraService.getTicketsData
};
